import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import About from './components/About';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import Features from './components/Features';
import Faq from './components/Faq';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Topics />
        <Carousel />
        <About />
        <IndexSection />
        <AppSection />
        <MediaSection />
        <Features />
        <Faq />
        <Cards />
        <Contact />
        <Updates />
        <Comments />
        <Ranking />
      </main>
      <Footer />
    </>
  );
}